import { render, staticRenderFns } from "./dirigentes-table.vue?vue&type=template&id=268f1ef8"
import script from "./dirigentes-table.vue?vue&type=script&lang=js"
export * from "./dirigentes-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports